import React, { useCallback, useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';

const BookDemoCalenderScreen = ({ data }) => {
  const namespace = 'ssjaiswal'; // e.g., 'dhruvjain'
  const calLink = 'ssjaiswal/30min'; // e.g., 'dhruvjain/30min'
  const name = data.first_name + ' ' + data.last_name;
  const email = data.email;

  const init = useCallback(async () => {
    const cal = await getCalApi({ namespace });

    cal('ui', {
      theme: 'light',
      styles: { branding: { brandColor: '#6922d6' } },
      hideEventTypeDetails: false,
      layout: 'month_view',
    });
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div className="w-full h-screen p-4">
      <div className="w-full h-[600px]">
        <Cal
          calLink={calLink}
          namespace={namespace}
          style={{ width: '100%', height: '100%', overflow: 'scroll' }}
          config={{
            theme: 'light',
            layout: 'month_view',
            name: name,
            email: email,
          }}
        />
      </div>
    </div>
  );
};

export default BookDemoCalenderScreen;
